import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AuthState } from 'src/app/services/auth/auth.model';
import { ToastService } from 'src/app/services/toast/toast.service';

import { AuthService } from 'src/app/services/auth/auth.service';
import { skipWhile, take } from 'rxjs/operators';
import { ADContactsBLL } from '../ad-contacts.bll';
import { createMask } from '@ngneat/input-mask';
import { currentSportsBLL } from '../../settings/components/sports/components/current_sports/current_sports.bll';
import { NewFieldEventBLL } from '../../my-schedules/new-field-events/new-field-event.bll';
@Component({
  selector: 'app-contacts-modal',
  templateUrl: './contacts-modal.component.html',
  styleUrls: ['./contacts-modal.component.scss'],
})
export class ContactsModalComponent implements OnInit {

  groupForm: FormGroup;
  isLoading$: Observable<boolean>;
  updateGroupLoading$: Observable<boolean>;
  isAddContactModelOpen$: Observable<boolean>;

  addGroupModal: boolean = false;

  updateContactModal: boolean = false;

  user: AuthState;
  selectedContact: any;

  // School search properties
  high_schools$: Observable<any>;
  is_high_school_loading$: Observable<boolean>;
  showSchoolOverlay: boolean = false;

  // Club search properties
  panda_clubs$: Observable<any>;
  is_club_loading$: Observable<boolean>;
  showClubOverlay: boolean = false;

  selected_account = localStorage.getItem('selected_account') ? localStorage.getItem('selected_account') : '1';
  ad_admin_id = localStorage.getItem('ad_admin_id');

  contactInputMask = createMask<string>({
    inputType: 'number',
    mask: '(999)999-9999',
    placeholder: '(xxx)xxx-xxxx',
    positionCaretOnClick: 'select'
  });


  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    private bll: ADContactsBLL,
    private auth: AuthService,
    private currentSportsBLL: currentSportsBLL,
    private fieldEventBLL: NewFieldEventBLL
  ) {
    this.groupForm = this.fb.group({
      name: ['', [Validators.required]],
      school: ['', [Validators.required]],
      club: [''],
      number: ['', [Validators.required]],
      email: ['', [Validators.required]]

    });
  }

  ngOnInit() {
    this.bll.selectedContact$.subscribe(Contact => {
      if (Contact) {
        this.selectedContact = Contact
        this.name?.setValue(Contact.name ?? '');
        this.school?.setValue(Contact.school ?? '');
        this.club?.setValue(Contact.club ?? '');
        this.number?.setValue(Contact.number ?? '');
        this.email?.setValue(Contact.email ?? '');
      }
    })
    this.bll.isUpdateContactModelOpen$.subscribe(isUpdate => {
      this.updateContactModal = isUpdate;
    })

    this.bll.prefillSchoolName$.subscribe(name => {
      if (name) {
        this.groupForm.patchValue({ school: name });
      }
    });

    this.bll.prefillWithCurrentUser$.subscribe((contactInfo: any) => {
      if (contactInfo) {
        this.groupForm.patchValue({ school: contactInfo.school, number: contactInfo.number, email: contactInfo.email, name: contactInfo.name });
      }
    });

    this.isAddContactModelOpen$ = this.bll.isAddContactModelOpen$;
    this.auth.auth$.pipe(skipWhile((val) => !val.token), take(1))
      .subscribe((val) => {
        this.user = val;
        if (this.user.id) {
          this.initObservables();
        }
      });
  }

  initObservables() {
    this.isLoading$ = this.bll.isLoading$;
    this.high_schools$ = this.currentSportsBLL.high_schools$;
    this.is_high_school_loading$ = this.currentSportsBLL.is_high_schools_loading$;
    this.panda_clubs$ = this.fieldEventBLL.panda_clubs$;
    this.is_club_loading$ = this.fieldEventBLL.is_panda_clubs_loading$;
  }

  onSchoolNameInput() {
    const schoolName = this.groupForm.get('school').value;
    if (schoolName?.length > 1) {
      this.currentSportsBLL.get_current_schools_email(schoolName, 'new-league');
    }
  }

  change_school_overlay(show: boolean) {
    this.showSchoolOverlay = show;
    if (show) {
      const schoolName = this.groupForm.get('school').value;
      if (schoolName?.length > 1) {
        this.currentSportsBLL.get_current_schools_email(schoolName, 'new-league');
      }
    } else {
      this.currentSportsBLL.clear_high_schools();
    }
  }

  change_school(school: any) {
    this.showSchoolOverlay = false;
    const schoolName = school.name || school.school;
    this.groupForm.patchValue({ school: schoolName });
    this.currentSportsBLL.clear_high_schools();
  }

  clear_school() {
    this.groupForm.patchValue({ school: '' });
    this.showSchoolOverlay = false;
    this.currentSportsBLL.clear_high_schools();
  }

  onClubNameInput() {
    const clubName = this.groupForm.get('club').value;
    if (clubName?.length > 1) {
      this.fieldEventBLL.get_panda_clubs(clubName);
    }
  }

  change_club_overlay(show: boolean) {
    this.showClubOverlay = show;
    if (show) {
      const clubName = this.groupForm.get('club').value;
      if (clubName?.length > 1) {
        this.fieldEventBLL.get_panda_clubs(clubName);
      }
    } else {
      this.fieldEventBLL.clear_panda_clubs();
    }
  }

  change_club(club: any) {
    this.showClubOverlay = false;
    const clubName = club?.name || club?.school_name;
    this.groupForm.patchValue({ club: clubName });
    this.fieldEventBLL.clear_panda_clubs();
  }

  clear_club() {
    this.groupForm.patchValue({ club: '' });
    this.showClubOverlay = false;
    this.fieldEventBLL.clear_panda_clubs();
  }

  resetModalState() {
    this.groupForm.reset();
  }

  updateContact() {
    this.bll.editContact(
      this.selectedContact.id, this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id : null
    );
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
    this.bll.toggleAddContactModel(false);
  }

  createContact() {
    this.bll.createContact(
      this.groupForm.value, this.selected_account == '2' ? this.ad_admin_id : null
    );
    this.resetModalState()
    this.bll.toggleAddContactModel(false);
  }

  closeModel(isOpen: boolean) {
    this.bll.toggleAddContactModel(isOpen);
    this.resetModalState()
    this.bll.changeUpdateContactModelOpen(false);
  }

  //#region FORM GETTERS

  get name() {
    return this.groupForm.get('name');
  }

  get school() {
    return this.groupForm.get('school');
  }

  get club() {
    return this.groupForm.get('club');
  }

  get number() {
    return this.groupForm.get('number');
  }

  get email() {
    return this.groupForm.get('email');
  }

  //#endregion FORM GETTERS

}
